import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

interface ChatSessionPaginationProps {
  page: number;
  totalPages?: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  onPageChange: (page: number) => void;
}

export const ChatSessionPagination = ({
  page,
  totalPages,
  hasPrevPage,
  hasNextPage,
  onPageChange,
}: ChatSessionPaginationProps) => {
  if (!hasPrevPage && !hasNextPage) {
    return null;
  }

  const canGoPrev = typeof totalPages === "number" && totalPages > 0 ? page > 1 : hasPrevPage;
  const canGoNext =
    typeof totalPages === "number" && totalPages > 0 ? page < totalPages : hasNextPage;

  return (
    <>
      <DropdownMenuSeparator className="my-2" />
      <div className="flex items-center justify-between gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            if (canGoPrev) {
              onPageChange(page - 1);
            }
          }}
          disabled={!canGoPrev}
          className="h-7 w-fit text-xs text-gray-600 disabled:opacity-50"
        >
          <ChevronLeft className="mr-1 size-3.5" />
        </Button>
        <span className="whitespace-nowrap text-xs text-gray-500">
          Page {page} {totalPages && `of ${totalPages}`}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            if (canGoNext) {
              onPageChange(page + 1);
            }
          }}
          disabled={!canGoNext}
          className="h-7 w-fit text-xs text-gray-600 disabled:opacity-50"
        >
          <ChevronRight className="ml-1 size-3.5" />
        </Button>
      </div>
    </>
  );
};
